import React from 'react'
import {Link} from 'gatsby'
import {css} from '@emotion/react'
import {useTranslation} from 'gatsby-plugin-react-i18next'

import UserDropdown from '../user-dropdown'
import rocketIcon from '../../../img/rocketIcon.png'
import {combine} from '../../styles/classname-utils'
import * as classes from './header.module.scss'
import {useUserContext, IUserContext} from '../../common/user-context'

const LoggedInNavbar = () => {
  const {t} = useTranslation(['navigation'])
  const {
    userAttributes,
    isUserEligibleForFreeTrial,
    signOut,
  }: IUserContext = useUserContext()

  return (
    <>
      <li className='nav-item'>
        <Link
          className={combine('nav-link', classes.navLink)}
          to='/docs/'
          a8='click;navigation;go-to-docs'
        >
          {t('header.link.documentation')}
        </Link>
      </li>

      <li className='nav-item'>
        <a
          className={combine('nav-link', classes.navLink)}
          href='/projects'
          a8='click;navigation;go-to-project-library'
        >
          {t('footer.link.project_library')}&nbsp;
          <img
            alt='rocket-icon'
            src={rocketIcon}
            style={{verticalAlign: 'middle', height: '1em'}}
          />
        </a>
      </li>

      <li className='nav-item'>
        <div
          className='dropdown'
          style={{padding: '0.5rem'}}
        >
          <a
            className={classes.dropMenu, classes.navLink}
            data-toggle='dropdown'
            aria-haspopup='true'
            aria-expanded='false'
            href=''
            a8='click;navigation;expand-product'
          >
            {t('header.heading.product')}&nbsp;<i className='fas fa-angle-down' style={{fontSize: '0.9rem'}} />
          </a>

          <div
            className={combine(
              'dropdown-menu',
              'justify-content-center',
              classes.dropdownMenuContent
            )}
            aria-labelledby='dropMenu'
          >
            <a
              className={combine(classes.dropdownItem, 'dropdown-item')}
              href='/discover'
              a8='click;navigation;go-to-discovery-hub'
            >
              {t('footer.link.discover')}
            </a>
            <Link
              className={combine(classes.dropdownItem, 'dropdown-item')}
              to='/products'
              a8='click;navigation;go-to-feature'
            >
              {t('header.link.features')}
            </Link>
            <Link
              className={combine(classes.dropdownItem, 'dropdown-item')}
              to='/pricing'
              a8='click;navigation;go-to-pricing'
            >
              {t('footer.link.pricing')}
            </Link>
          </div>
        </div>
      </li>

      <li className='nav-item'>
        <div
          className='dropdown'
          style={{padding: '0.5rem'}}
        >
          <a
            className={classes.dropMenu, classes.navLink}
            data-toggle='dropdown'
            aria-haspopup='true'
            aria-expanded='false'
            href=''
            a8='click;navigation;expand-learn'
          >
            {t('footer.heading.learn')}&nbsp;<i className='fas fa-angle-down' style={{fontSize: '0.9rem'}} />
          </a>

          <div
            className={combine(
              'dropdown-menu',
              'justify-content-center',
              classes.dropdownMenuContent
            )}
            aria-labelledby='dropMenu'
          >
            <a
              className={combine(classes.dropdownItem, 'dropdown-item')}
              href='/forum'
              target='_blank'
              rel='noopener noreferrer'
              a8='click;navigation;go-to-forum'
            >
              {t('header.link.forum')}
            </a>
            <Link
              className={combine(classes.dropdownItem, 'dropdown-item')}
              to='/tutorials'
              a8='click;navigation;go-to-tutorials'
            >
              {t('footer.link.tutorials')}
            </Link>
            <a
              className={combine(classes.dropdownItem, 'dropdown-item')}
              href='/blog'
              a8='click;navigation;go-to-blog'
            >
              {t('footer.link.blog')}
            </a>
            <a
              className={combine(classes.dropdownItem, 'dropdown-item')}
              href='https://github.com/8thwall/web'
              a8='click;navigation;go-to-git-hub'
            >
              GitHub
            </a>
          </div>
        </div>
      </li>

      <li className='nav-item'>
        <Link
          className={combine('nav-link', classes.navLink)}
          to='/resources'
          a8='click;navigation;go-to-support'
        >
          {t('footer.link.support')}
        </Link>
      </li>

      {isUserEligibleForFreeTrial &&
        <>
          <li className='nav-item d-none d-lg-block'>
            <a
              href='/start-your-free-trial'
              a8='click;navigation;go-to-free-trial'
              className={combine('create-acct', classes.createAcct)}
            >
              {t('header.link.start_trial')}
            </a>
          </li>
          <li className='nav-item d-lg-none'>
            <a
              href='/start-your-free-trial'
              a8='click;navigation;go-to-free-trial'
            >
              <button
                type='button'
                className='btn btn-primary custom-btn'
                css={css`
                    margin: 0.5rem auto;
                    padding-top: 0.25em;
                    padding-bottom: 0.25em;
                  `}
              >
                {t('header.link.start_trial')}
              </button>
            </a>
          </li>
        </>}

      <li className='nav-item'>
        <UserDropdown
          user={userAttributes}
          signOut={signOut}
        />
      </li>
    </>
  )
}

export default LoggedInNavbar
